<template>
    <v-layout justify-center>
        <v-responsive width="100%" height="100%">
            <list-heading title="리워드 캐시 내역" v-model="showsSearch" showsFilterButton />

            <list-search
                v-bind="{ showsSearch }"
                @search="
                    page = 1;
                    search(true);
                "
            >
                <v-row class="ma-n2">
                    <v-col cols="6" lg="3" class="pa-2">
                        <v-text-field v-model="filter.createdAt[0]" type="date" clearable label="기간검색(시작일)" persistent-placeholder hide-details dense outlined />
                    </v-col>
                    <v-col cols="6" lg="3" class="pa-2">
                        <v-text-field v-model="filter.createdAt[1]" type="date" clearable label="기간검색(종료일)" persistent-placeholder hide-details dense outlined />
                    </v-col>
                    <v-col cols="6" lg="3" class="pa-2">
                        <v-select v-model="filter.searchKey" :items="searchKeys" item-text="text" item-value="value" label="검색조건" persistent-placeholder hide-details dense outlined @input="filter.searchValue = null" />
                    </v-col>
                    <v-col cols="6" lg="3" class="pa-2">
                        <v-text-field
                            v-model="filter.searchValue"
                            label="검색어"
                            persistent-placeholder
                            hide-details
                            dense
                            outlined
                            :disabled="!filter.searchKey"
                            @keydown.enter="
                                page = 1;
                                search(true);
                            "
                        ></v-text-field>
                    </v-col>
                </v-row>
            </list-search>

            <v-row class="ma-n2 mt-n1">
                <v-spacer />
                <v-col class="pa-2" cols="auto">
                    <list-excel v-slot="{ attrs, on }" v-on="{ excel }">
                        <v-card outlined style="overflow: hidden;">
                            <v-btn color="white" elevation="0" class="text-caption green--text" style="margin:-1px" v-bind="{ ...attrs, loading }" v-on="on">
                                <v-icon> mdi-microsoft-excel </v-icon>
                                <span> 엑셀다운로드 </span>
                            </v-btn>
                        </v-card>
                    </list-excel>
                </v-col>
                <v-col class="pa-2" cols="12">
                    <v-data-table v-bind="{ loading, headers, items }" disable-sort disable-pagination hide-default-footer class="v-sheet--outlined" :items-per-page="-1" ref="data-table">
                        <template v-for="(header, index) in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> <span :key="index" :title="header.withTitle ? header.formatter.bind(item)(value, item) : undefined" v-html="header.formatter.bind(item)(value, item)" /> </template>

                        <template #footer>
                            <v-divider />
                            <v-pagination v-model="page" :length="pageCount" total-visible="11" class="my-2" @input="search(true)" />
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { initDataTableHeaders } from "@/assets/lib";

import ListExcel from "@/components/console/dumb/list-excel.vue";
import ListHeading from "@/components/console/dumb/list-heading.vue";
import ListSearch from "@/components/console/dumb/list-search.vue";
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";

const adsTypes = {
    [1]: "CPI",
    [2]: "CPE",
    [3]: "CPA",
    [4]: "CPS",
    [6]: "CPC",
    [7]: "CPSNS",
    [8]: "뉴스 피드 적립형",
};

const headers = initDataTableHeaders([
    { text: "생성일자", value: "createdAt", formatterType: "datetime", width: 180 },
    { text: "광고유형", value: "ads.type", formatter: (value) => adsTypes[value] || value },
    { text: "광고ID", value: "ads.idx", width: 100 },
    { text: "광고명", value: "ads.name" },
    { text: "adid 또는 idfa", value: "ads.meta.adid_or_idfa" },
    { text: "gp_key", value: "ads.meta.gp_key", width: 100 },
    { text: "중복참여\n가능여부", value: "ads.meta.ads_re_participate", width: +80 },
    { text: "캐시내역", value: "remark" },
    { text: "금액", value: "amount", formatterType: "number", width: +80 },
    { text: "잔액", value: "result", formatterType: "number", width: 100 },
    { text: "단가", value: "ads.meta.rwd_cost", formatterType: "number", width: +80 },
    { text: "ID", value: "member.username", width: 80 },
    { text: "이름", value: "member.name", width: 100 },
]);

export default {
    components: {
        ListExcel,
        ListHeading,
        ListSearch,
        VDateField,
    },
    data() {
        return {
            loading: true,
            showsSearch: true,
            pinStatusDialog: false,

            filter: {
                type: JSON.stringify({ $in: ["리워드"] }),
                createdAt: [
                    this.$route.query.createdAt?.[0] ||
                        this.$dayjs()
                            .startOf("year")
                            .format("YYYY-MM-DD"),
                    this.$route.query.createdAt?.[1] ||
                        this.$dayjs()
                            .endOf("year")
                            .format("YYYY-MM-DD"),
                ],
                searchKey: this.$route.query.searchKey || null,
                searchValue: this.$route.query.searchValue || null,
            },

            searchKeys: [
                { text: ":: 전체 ::", value: null },
                { text: "이름", value: "member.name" },
                { text: "아이디", value: "member.username" },
                { text: "연락처", value: "member.phone" },
                { text: "광고ID", value: "ads.idx" },
                { text: "광고명", value: "ads.name" },
                { text: "gp_key", value: "tno" },
            ],

            page: 1,
            pageCount: 0,
            limit: 20,

            excelLimit: 0,

            cashes: [],
            headers,

            selected: [],
        };
    },
    computed: {
        items() {
            return this.cashes;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.search();
        },
        async search(routable = false) {
            if (routable) {
                this.$router.push({
                    query: { ...this.filter, page: this.page },
                });
            }

            this.loading = true;
            this.cashes = [];

            var { summary, cashes } = await api.console.cashes.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit,
                },
                params: this.filter,
            });

            this.loading = false;
            this.cashes = cashes;
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
            this.excelLimit = summary.totalCount <= 100000 ? summary.totalCount : 100000;
        },

        async excel({ skip = 0, limit = 0 } = {}) {
            if (this.loading) return;
            else this.loading = true;

            try {
                var { cashes } = await api.console.cashes.gets({
                    headers: { skip, limit },
                    params: this.filter,
                });

                let { headers } = this;
                let fileName = "교환내역";
                this.$excel(cashes, headers, fileName);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .line-height-1-5 {
        line-height: 1.5;
    }
    .max-width-0 {
        max-width: 0;
    }
    .word-break-keep-all {
        word-break: keep-all;
    }
    .white-space-pre-line {
        white-space: pre-line;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .v-pagination button {
        box-shadow: none !important;
        border: thin solid rgba(0, 0, 0, 0.12);
    }
    .v-small-dialog__activator {
        height: 100%;
    }
    .v-small-dialog__activator__content {
        width: 100%;
    }

    th:first-of-type:not(:last-of-type),
    td:first-of-type:not(:last-of-type) {
        border-right: thin solid rgba(0, 0, 0, 0.12);
    }

    .v-data-table__expanded__content {
        box-shadow: none !important;
    }
    .vertical-align-top {
        vertical-align: top !important;
    }
    .vertical-align-middle {
        vertical-align: middle !important;
    }
}
</style>
